"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = exports.getItem = void 0;
var _getTime = _interopRequireDefault(require("date-fns/getTime"));
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var setItem = exports.setItem = function setItem(_ref) {
  var key = _ref.key,
    payload = _ref.payload,
    _ref$ttl = _ref.ttl,
    ttl = _ref$ttl === void 0 ? 30 : _ref$ttl;
  var today = new Date();
  var expiry = (0, _addDays["default"])(today, ttl);
  var timestamp = (0, _getTime["default"])(expiry);

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  var item = {
    payload: payload,
    timestamp: timestamp
  };
  window.localStorage.setItem(key, JSON.stringify(item));
};
var getItem = exports.getItem = function getItem(_ref2) {
  var key = _ref2.key;
  var now = Date.now();
  var storageItem = window.localStorage.getItem(key);
  if (!storageItem) {
    return null;
  }
  var item = JSON.parse(storageItem);
  // compare the expiry time of the item with the current time
  if (now > item.timestamp) {
    // If the item is expired, delete the item from storage
    // and return null
    window.localStorage.removeItem(key);
    return null;
  }
  return item.payload;
};